export default __webpack_public_path__ + "static/media/SDG13.d8ae0edd.png";